import { lazyLoad } from 'utils/loadable';

export const UnitDetailsLandingPageLoadable = lazyLoad(
  () => import('./UnitLandingPageWrapper'),
  module => module.UnitDetailsLandingPage,
);
